<script lang="ts">
    import type {LocalizeFunction} from '../../svelte/types';
    import {getContext} from 'svelte';
    import {LOCALIZE_KEY} from '../../svelte/utils';
    import KpRecordCollectionsTreeList from '../kp-record-collections-tree-list/KpRecordCollectionsTreeList.svelte';

    const localize: LocalizeFunction = getContext(LOCALIZE_KEY);
</script>

<template>
    <div class="row">
        <h1 class="col-sm-12">{localize(/* @kp-localization recordCollections.Collections */ 'recordCollections.Collections')}</h1>
    </div>

    <div class="row">
        <div class="col-sm-8 main-panel-hlavni ">
            <KpRecordCollectionsTreeList/>
        </div>
    </div>
</template>
